
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vehicle/[vehicleId]",
      function () {
        return require("private-next-pages/vehicle/[vehicleId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vehicle/[vehicleId]"])
      });
    }
  